import { useState } from 'react'
import { PieImage } from 'components/common'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'

interface PaymentFailedModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	eventAvatarUrl?: string | null
	onClosed?: () => void
}

export function PaymentFailedModal({ open, setOpen, eventAvatarUrl, onClosed }: PaymentFailedModalProps) {
	return (
		<ConfirmationModal
			open={open}
			setOpen={setOpen}
			blur
			size="sm"
			hideCloseButton={false}
			title="Unsuccessful Payment"
			onClosed={onClosed}
		>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[280px]">
					<div className="mt-5">Your payment method failed during check out .</div>
					<div className="flex justify-center items-center py-9">
						<PieImage className="w-32 h-auto rounded-lg flex-shrink-0" images={[eventAvatarUrl]} />
					</div>
					<div className="text-white">Please try purchasing your ticket again.</div>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface PaymentFailedModalManagedProps {
	eventAvatarUrl?: string | null
	onClosed?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'payment-failed': PaymentFailedModalManagedProps
	}
}

export function ManagedPaymentFailedModal({
	onClose,
	...rest
}: PaymentFailedModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<PaymentFailedModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onClosed={handleClose}
			{...rest}
		/>
	)
}
